"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Backdrop", {
    enumerable: true,
    get: function() {
        return Backdrop;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _BodyPortal = require("../BodyPortal/BodyPortal");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Backdrop = (param)=>{
    let { zIndex } = param;
    return /*#__PURE__*/ _react.default.createElement(_BodyPortal.BodyPortal, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "9d5330ea142f3703",
                [
                    zIndex !== null && zIndex !== void 0 ? zIndex : 1000
                ]
            ]
        ]) + " " + "overlay-backdrop"
    }, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "9d5330ea142f3703",
        dynamic: [
            zIndex !== null && zIndex !== void 0 ? zIndex : 1000
        ]
    }, "div.__jsx-style-dynamic-selector{position:fixed;top:0;left:0;width:100vw;height:100vh;background:#000;opacity:.4;z-index:".concat(zIndex !== null && zIndex !== void 0 ? zIndex : 1000, "}"))));
};

//# sourceMappingURL=Backdrop.js.map